// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ButtonGroup, LgPadding } from '@alto/design-system';
import React from 'react';
import { type ShipmentMethod, type ShipmentStatus } from '~shared/types';
import { CancelButton } from './CancelButton';
import { DownloadReceiptButton } from './DownloadReceiptButton';
import { EditButton } from './EditButton';
import { SnoozeButton } from './SnoozeButton';

type ActionButtonsGroupProps = {
  readonly charged?: boolean;
  readonly handleDownloadReceipt: () => void;
  readonly handleEditShipment: () => void;
  readonly handleOpenSnooze?: () => void;
  readonly method?: ShipmentMethod;
  readonly openCancelDeliveryModal: () => void;
  readonly shipmentID: number;
  readonly shipmentIsEditable?: boolean;
  readonly status?: ShipmentStatus;
  readonly userID?: number;
};

export const ActionButtonsGroup = ({
  charged = false,
  handleDownloadReceipt,
  handleEditShipment,
  handleOpenSnooze,
  method,
  openCancelDeliveryModal,
  shipmentID,
  shipmentIsEditable,
  status,
  userID,
}: ActionButtonsGroupProps) => {
  if (!shipmentIsEditable && charged) {
    return (
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <ButtonGroup
          buttons={[
            <DownloadReceiptButton
              key="Download receipt button"
              charged={charged}
              handleDownloadReceipt={handleDownloadReceipt}
              shipmentID={shipmentID}
            />,
          ]}
          inline
          justifyButtons="left"
        />
      </LgPadding>
    );
  }

  return (
    <LgPadding topPadding={SPACING.STATIC.NONE}>
      <ButtonGroup
        buttons={[
          <EditButton
            key="Edit delivery button"
            handleEditShipment={handleEditShipment}
            method={method}
            shipmentID={shipmentID}
            shipmentIsEditable={shipmentIsEditable}
            status={status}
          />,
          <DownloadReceiptButton
            key="Download receipt button"
            charged={charged}
            handleDownloadReceipt={handleDownloadReceipt}
            shipmentID={shipmentID}
          />,
          <SnoozeButton
            key="Snooze delivery button"
            handleOpenSnooze={handleOpenSnooze}
            shipmentID={shipmentID}
            userID={userID}
          />,
          <CancelButton
            key="Cancel delivery button"
            openCancelDeliveryModal={openCancelDeliveryModal}
            shipmentIsEditable={shipmentIsEditable}
            status={status}
          />,
        ]}
        inline
        justifyButtons="left"
      />
    </LgPadding>
  );
};
